<div
  class="bi"
  [class.bi--disabled]="inputDisabled"
  [class.bi--readonly]="inputReadonly && !inputDisabled"
  [class.bi--no-action]="!showAction"
  [class.bi--compact]="size === 'compact'"
  [class.bi--has-prefix]="showPrefix && currencyPrefix"
  [class.bi--has-suffix]="!!suffix"
>
  <span class="bi__prefix" *ngIf="showPrefix && currencyPrefix">{{ currencyPrefix }}</span>
  <input
    class="bi__input"
    [id]="inputId || null"
    [type]="useNumberInput && !allowDecimal ? 'number' : 'text'"
    [attr.inputmode]="allowDecimal ? 'decimal' : null"
    [attr.placeholder]="placeholder || null"
    [value]="displayValue"
    (input)="onInput($event)"
    (blur)="onTouched()"
    [disabled]="effectiveDisabled"
    [readonly]="effectiveReadonly"
    [attr.step]="useNumberInput ? inputStep : null"
    [min]="minInput"
    [attr.max]="maxInput"
    (keydown)="blockInvalidKeys($event)"
  />
  <span class="bi__suffix" *ngIf="suffix">{{ suffix }}</span>

  <button
    *ngIf="showAction"
    type="button"
    class="bi__btn"
    [class.bi__btn--active]="!actionDisabled && !isBelowMin"
    [disabled]="actionDisabled"
    (click)="onActionClick()"
  >
    {{ buttonText }}
  </button>
</div>
